import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22185 21635"
    {...props}
  >
    <path
      d="M11092 123c0 8426-1866 9324-8796 4236 6930 5088 6470 7108-2173 9519 8643-2411 9934-792 6088 7634 3846-8426 5917-8426 9763 0-3846-8426-2554-10045 6088-7634-8642-2411-9104-4431-2172-9519-6932 5088-8798 4190-8798-4236z"
      style={{
        // fill: "#1c1b17",
        // stroke: "#1c1b17",
        strokeWidth: 245.851,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
